import { format } from 'date-fns';
import QRCode from 'qrcode';

// ----------------------------------------------------------------------

/**
 * Exports a QR code as a PNG image file
 * @param encryptedData - The encrypted data to encode in the QR code
 * @param branchName - The branch name to include in the filename
 * @returns Promise that resolves when the download is complete
 * @throws Error if QR code generation fails
 */
export async function exportQrCodeAsPng(
  encryptedData: string,
  branchName: string
): Promise<void> {
  try {
    // Generate QR code as data URL (512x512 px)
    const dataUrl = await QRCode.toDataURL(encryptedData, {
      width: 512,
      margin: 1,
      errorCorrectionLevel: 'M',
    });

    // Convert data URL to blob
    const response = await fetch(dataUrl);
    const blob = await response.blob();

    // Generate filename with timestamp
    const timestamp = format(new Date(), 'yyyy-MM-dd-HHmmss');
    const filename = `QR-${branchName}-${timestamp}.png`;

    // Create download link and trigger download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.style.display = 'none';

    // Append to body, click, and cleanup
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup blob URL
    URL.revokeObjectURL(link.href);
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error occurred';
    throw new Error(`Failed to generate QR code: ${errorMessage}`);
  }
}
